module.exports = __webpack_public_path__ + "static/media/tutorial-06.a14ea3a1.jpg";